module.exports = __webpack_public_path__ + "img/zxhg.9e15328a.png";